import { translator } from "@shop/frontend/web/js/services/TranslatorService";

import { EventEmitter } from "../EventEmitter";

export class TimerView extends EventEmitter {
	constructor() {
		super();
		this.timer = $(".js-order-timer");
	}

	show({ hours, minutes, seconds }) {
		let text = ("0" + seconds).slice(-2) + " " + translator.t("main", "sec.");
		if (minutes > 0) {
			text = ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
		}
		if (hours > 0) {
			text =
				("0" + hours).slice(-2) +
				":" +
				("0" + minutes).slice(-2) +
				":" +
				("0" + seconds).slice(-2);
		}
		this.timer.text(text);
	}

	hide() {
		this.emit("hideTime");
	}
}
